import { AsidePanelActionsButton } from '../../../../..';
import * as React from 'react';
import { IArchiveOnDeletePanelButtonProps } from './types';
import { BOARD_SECTION_ARCHIVE_ON_DELETE_BUTTON } from '../../constants';
import { AsidePanelContext } from '../../../../../asidePanel/components/AsidePanel/constants';
import { EBoardSetting } from '../../../TabDetails/components/TabDetails/types';

export function ArchiveOnDeletePanelButton ({
    indicatorBoolean,
    isEssentialFeature,
    isDisabled,
    tooltip,
    onClick
}: IArchiveOnDeletePanelButtonProps) {
    const { subTab, setSubTab } = React.useContext(AsidePanelContext);
    return (
        <AsidePanelActionsButton
            children={null}
            isOpened={subTab === EBoardSetting.ARCHIVE_UPON_DELETION}
            indicatorBoolean={indicatorBoolean}
            isEssentialFeature={isEssentialFeature}
            isDisabled={isDisabled}
            title={BOARD_SECTION_ARCHIVE_ON_DELETE_BUTTON}
            tooltip={tooltip}
            onClick={() => {
                setSubTab(EBoardSetting.ARCHIVE_UPON_DELETION);
                onClick();
            }}
        />
    );
}
